import React from "react";

export type AlertPopupType = "success" | "danger";

interface AlertPopupProps {
  open: boolean;
  alertType: AlertPopupType;
  actionText?: string;
  heading: string;
  message: string;
  onCancel: () => void;
  onProceed: () => void;
  proceedLabel?: string;
}

const AlertPopup: React.FC<AlertPopupProps> = ({
  open,
  alertType,
  actionText,
  heading,
  message,
  onCancel,
  onProceed,
  proceedLabel = "Proceed",
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="custom-alert-overlay" onClick={onCancel}>
      <div
        className={`custom-alert-modal ${alertType}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="custom-alert-header">
          <div className="custom-alert-heading-group">
            {actionText ? (
              <span className="custom-alert-kicker">{actionText}</span>
            ) : null}
            <h3>{heading}</h3>
          </div>
          <button
            type="button"
            className="custom-alert-close"
            onClick={onCancel}
            aria-label="Close alert"
          >
            x
          </button>
        </div>
        <div className="custom-alert-body">
          <p>{message}</p>
        </div>
        <div className="custom-alert-actions">
          <button
            type="button"
            className="custom-alert-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`custom-alert-proceed ${alertType}`}
            onClick={onProceed}
          >
            {proceedLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertPopup;
